<template>
  <!-- A student's session ended: he came from the Facilauto app with a token
       of his own and has no login here, so the only way on is back. -->
  <div class="session-expired">
    <div class="session-expired-card">
      <div class="session-expired-icon">
        <font-awesome-icon :icon="['far', 'clock']" />
      </div>
      <h1>{{ s.expired_title }}</h1>
      <p>{{ s.expired_text }}</p>
      <button class="h-button w-100" v-on:click="app.methods.back()">{{ s.back }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'session-expired-view',
  props: [
    'app'
  ],
  computed: {
    s () {
      return this.app.strings.app.session
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/variables-app.scss";
@import "@/assets/styles/variables-valkiria.scss";

.session-expired {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  background-color: #f6f8fb;
}

.session-expired-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 400px;
  padding: 32px 24px 24px;
  box-sizing: border-box;
  border: 1px solid $color-grey-light;
  border-radius: 20px;
  background-color: #FFFFFF;
  box-shadow: 0 12px 30px rgba(20, 67, 107, 0.06);
  text-align: center;
}

.session-expired-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-bottom: 18px;
  border-radius: 999px;
  background-color: #eaf3fb;
  color: $color-primary-1;
  font-size: 28px;
}

.session-expired h1 {
  margin: 0 0 8px;
  color: $text-color-1;
  font-family: 'Lexend', sans-serif;
  font-size: 20px;
}

.session-expired p {
  margin: 0 0 24px;
  color: $text-color-2;
  font-size: 15px;
  line-height: 1.45;
}
</style>
